import classNames from 'classnames';
import React from 'react';
import { ReactNode } from 'react';
import classes from './index.module.scss';

interface State {
  hasError: boolean;
}

interface Properties {
  children: ReactNode;
}

/**
 * The component to handle errors ui
 * @returns {React.ReactComponentElement} the component element
 */
class ErrorCatcher extends React.Component<Properties, State> {
  static displayName: string;
  /**
   * The constructor of the component
   * @param {*} properties the properties
   */
  constructor(properties: Properties) {
    super(properties);
    this.state = { hasError: false };
  }

  /**
   * The static method to get the error
   * @returns {*} the new state
   */
  static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  /**
   * The method to catch the error
   */
  componentDidCatch(error: Error): void {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    // eslint-disable-next-line no-console
    console.error('error boundary', error);
  }

  /**
   * The method to render
   * @returns {React.ReactComponentElement} the component to return
   */
  render(): ReactNode {
    const {
      state: { hasError = false },
      props,
    } = this;
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <div
          className={classNames(
            'pmi-h-100 pmi-d-flex pmi-flex-column pmi-align-items-center pmi-justify-content-center',
            classes.pmiErrorContainer
          )}
        >
          <h1>500</h1>
          <p className="pmi-mb-1"> Whooops! Qualcosa è andato storto.</p>
          <a href="/">Aggiorna la pagina!</a>
        </div>
      );
    }

    return props.children;
  }
}

ErrorCatcher.displayName = 'Error catcher component';

export default ErrorCatcher;
